import { render } from "./Institutions.vue?vue&type=template&id=4ff29cbb&scoped=true"
import script from "./Institutions.vue?vue&type=script&lang=js"
export * from "./Institutions.vue?vue&type=script&lang=js"

import "./Institutions.vue?vue&type=style&index=0&id=4ff29cbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff29cbb"]])

export default __exports__